<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="ql-editor"
    :class="{ 'text-caption': isTextCaption }"
    v-html="sanitizedContent"
  />
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "BaseMarkdownViewer",
  props: {
    content: {
      type: String,
      default: "",
    },
    isTextCaption: {
      type: Boolean,
    },
  },
  computed: {
    // Ensure content is sanitized to prevent XSS attacks
    sanitizedContent() {
      return DOMPurify.sanitize(this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~quill/dist/quill.core.css";
.ql-editor {
  width: 100%;
  margin: 0;
  padding: 0;
  min-height: auto;
}
.text-caption {
  font-size: 0.625rem !important;
  font-weight: 400;
}
</style>
